/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { Popover as BPopover, PopoverBody } from 'reactstrap';

import '../../styles/input/popover.scss';

const Popover = (props) => {
  const { children, title, id } = props;
  const [isOpen, toggleIsOpen] = useState(false);
  const popover = useRef();

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const handleClick = (e) => {
    if (popover.current && popover.current.contains(e.target)) {
      return;
    }
    toggleIsOpen(false);
  };

  return (
    <a
      className="popover-wrapper"
      role="presentation"
      id={`tooltip-${id}`}
      onClick={() => toggleIsOpen(!isOpen)}
      ref={popover}
    >
      {title || (
        <img src="/img/table-popup.svg" alt="info" data-gumlet="false" />
      )}
      <BPopover placement="bottom-end" isOpen={isOpen} target={`tooltip-${id}`} className="table-popover">
        <PopoverBody>
          {children}
        </PopoverBody>
      </BPopover>
    </a>
  );
};

Popover.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string,
  id: PropTypes.string
};

Popover.defaultProps = {
  title: '',
  id: ''
};

export default Popover;
